exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box-error-cart{background-color:#fff;padding:10px;border:1px solid #c7c7c7;border-radius:4px;box-shadow:1px 1px 5px #bbb}", ""]);

// exports
